const MIN_PHONE_NUMBER_LENGTH = 10;
const MAX_PHONE_NUMBER_LENGTH = 15;

export const validatePhoneNumber = (input: string): boolean => {
  if (!input || typeof input !== 'string') {
    return false;
  }

  // Disallow multiple '+' signs or '+' not at the start
  if (!/^\+?[^+]*$/.test(input)) {
    return false;
  }

  const digits = input.replace(/\D/g, '');

  // Check digit count range (E.164 allows 10–15 digits)
  if (digits.length < MIN_PHONE_NUMBER_LENGTH || digits.length > MAX_PHONE_NUMBER_LENGTH) {
    return false;
  }

  // Disallow if all digits are the same (e.g., 1111111111)
  const isAllSameDigit = digits.split('').every((d) => d === digits[0]);
  if (isAllSameDigit) {
    return false;
  }

  return true;
};
